import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import CrApp from './CrApp';
import TvShows from './TvShows';
import VideoPlayer from './videoPlayer';
import TvShowVideoPlayer from './TvShowVideoPlayer';
import SignInSide from './SignInSide';
import SignUpPage from './SignUpPage';
import { ClerkProvider, RedirectToSignIn, SignedIn, SignedOut } from '@clerk/clerk-react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Publishable Key")
}

const ClerkWithRouter = () => {
  const navigate = useNavigate();

  return (
    <ClerkProvider
      publishableKey={PUBLISHABLE_KEY}
      navigate={(to) => navigate(to)}
    >
      <Routes>
        <Route exact path="/" element={<SignInSide />}/>
        <Route exact path="/SignUp" element={<SignUpPage />}/>
        <Route exact path="/home" element={ <><SignedIn><CrApp /></SignedIn><SignedOut><RedirectToSignIn /></SignedOut></>} />
        <Route exact path="/TvShows" element={ <><SignedIn><TvShows /></SignedIn><SignedOut><RedirectToSignIn /></SignedOut></>} />
        <Route path="/TvShows/:tvShowName/:season/:episode" element={<><SignedIn><TvShowVideoPlayer /></SignedIn><SignedOut><RedirectToSignIn /></SignedOut></>} />
        <Route path="/:name" element={<><SignedIn><VideoPlayer /></SignedIn><SignedOut><RedirectToSignIn /></SignedOut></>} />
      </Routes>
    </ClerkProvider>
  );  

}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <ClerkWithRouter />
    </Router>
  </React.StrictMode>
);
